module.exports = __webpack_public_path__ + "static/media/6.14.319a5258.png";